<template>
    <tbody :class="index % 2 === 0 ? 'bg-gray-100' : 'bg-white'">
        <tr class="hover:bg-gray-200">
            <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900">
                <div class="flex space-x-2 items-center">
                    <img
                        :src="student.avatar_or_default"
                        :alt="student.full_name"
                        :title="student.full_name"
                        class="rounded-full h-10"
                    />
                    <div>{{ student.index }}. {{ student.full_name }}</div>
                </div>
            </td>
            <td
                class="flex items-center px-4 sm:px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
            >
                <div>
                    {{ totalScore }}
                </div>
                <div class="ml-3 text-gray-600">/ {{ activityResponse.max_score }}</div>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900">
                <!--                                    v-if="activity.max_score !== 10"-->
                <!--                                     translateToDecimal(activityResponse.score) -->
                <BadgePill v-if="activityResponse.pill.color" :color="activityResponse.pill.color">{{
                    activityResponse.pill.decimal_score
                }}</BadgePill>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900">
                <input
                    type="text"
                    :list="`datalist_comment_${activityResponse.student_id}`"
                    v-model="activityResponse.comment"
                    maxlength="180"
                    :name="'comment[' + activityResponse.student_id + ']'"
                    class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                />
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900">
                <label>
                    <svg
                        class="w-4 h-4 focus:ring-indigo-500"
                        :class="activityResponse.adapted ? 'text-indigo-600' : 'text-gray-400'"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-2 0c0 .993-.241 1.929-.668 2.754l-1.524-1.525a3.997 3.997 0 00.078-2.183l1.562-1.562C15.802 8.249 16 9.1 16 10zm-5.165 3.913l1.58 1.58A5.98 5.98 0 0110 16a5.976 5.976 0 01-2.516-.552l1.562-1.562a4.006 4.006 0 001.789.027zm-4.677-2.796a4.002 4.002 0 01-.041-2.08l-.08.08-1.53-1.533A5.98 5.98 0 004 10c0 .954.223 1.856.619 2.657l1.54-1.54zm1.088-6.45A5.974 5.974 0 0110 4c.954 0 1.856.223 2.657.619l-1.54 1.54a4.002 4.002 0 00-2.346.033L7.246 4.668zM12 10a2 2 0 11-4 0 2 2 0 014 0z"
                            clip-rule="evenodd"
                        ></path>
                    </svg>
                    <input
                        v-model="activityResponse.adapted"
                        type="checkbox"
                        name="adapted[]"
                        :value="activityResponse.student_id"
                        class="hidden focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                    />
                </label>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900">
                <input
                    v-model="activityResponse.absent"
                    name="absent[]"
                    :disabled="!(activityResponse.score === null || activityResponse.score === '')"
                    :value="activityResponse.student_id"
                    type="checkbox"
                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                />
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900">
                <input
                    v-model="activityResponse.signed"
                    type="checkbox"
                    name="signed[]"
                    :value="activityResponse.student_id"
                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                />
            </td>
        </tr>
        <tr
            class="hover:bg-gray-200"
            v-for="(subactivityResponse, subIndex) in activityResponse.subactivity_responses"
            :key="subactivityResponse.subactivity_id"
        >
            <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900">
                {{ subactivityResponse.subactivity_name }}
            </td>
            <td class="px-4 sm:px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900">
                <div class="flex items-center">
                    <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                            v-model.number="subactivityResponse.score"
                            type="number"
                            step="0.01"
                            :max="subactivityResponse.max_score"
                            min="0"
                            :tabindex="index + 2"
                            class="invalid:border-red-500 disable-input-arrows max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                            style="min-width: 70px"
                        />
                        <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <span class="hidden xl:inline-block">/ {{ subactivityResponse.max_score }}</span>
                        </div>
                    </div>
                    <div class="block xl:hidden ml-3">/ {{ subactivityResponse.max_score }}</div>
                </div>
                <FormError :value="errors[`students.${index}.activity_response.subactivity_responses.${subIndex}`]" />
            </td>
            <td colspan="5" class="px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900">-</td>
        </tr>
        <tr class="hover:bg-gray-200">
            <td class="px-6 py-4" colspan="7">
                <div class="mt-1">
                    <FormLabel :value="$t('messages.feedback_for_students')" for="comment" />
                    <FormTextarea
                        rows="3"
                        id="comment"
                        v-model="activityResponse.feedback"
                        name="comment"
                        type="text"
                        class="mt-1 w-full"
                    />
                    <FormError :value="errors[`students.${index}.activity_response.feedback`]" />
                </div>
            </td>
        </tr>
    </tbody>
</template>
<script>
import FormError from '@/components/Forms/FormError.vue';
import FormTextarea from '@/components/Forms/FormTextarea.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import BadgePill from '@/components/BadgePill.vue';

export default {
    name: 'ActivityResponseGrade',
    components: {
        FormError,
        BadgePill,
        FormTextarea,
        FormLabel,
    },
    props: {
        student: {
            required: true,
        },
        modelValue: {
            required: true,
        },
        errors: {
            required: true,
        },
        index: {
            required: true,
            type: Number,
        },
        gradeTranslator: {
            required: true,
            type: Object,
        },
    },
    emits: ['update:modelValue'],
    data: function () {
        return {
            activityResponse: this.modelValue,
        };
    },
    computed: {
        totalScore() {
            let scores = this.activityResponse.subactivity_responses
                .filter((s) => s.score !== null)
                .filter((s) => s.score !== '')
                .filter((s) => s.score <= s.max_score);

            if (scores.length === 0) {
                return null;
            }

            return scores.map((s) => s.score).reduce((total, item) => total + item);
        },
        totalDecimalScore() {
            if (this.totalScore === null) {
                return null;
            }

            return (this.totalScore / this.activityResponse.max_score) * 10;
        },
    },
    watch: {
        totalDecimalScore: {
            immediate: true,
            deep: true,
            handler: function (value) {
                this.activityResponse.absent = value === null;
                this.activityResponse.decimal_score = value;
                this.activityResponse.pill = this.gradeTranslator.scoreToPill(value);
                this.$emit('update:modelValue', this.activityResponse);
            },
        },
    },
};
</script>
